class RelativeLink extends HTMLElement {
  connectedCallback() {
    const anchor = this.querySelector("a");
    if (!anchor) return;

    try {
      const url = new URL(anchor.href);
      anchor.href = url.pathname + url.search + url.hash;
    } catch (e) {
      // href is already relative or invalid — leave it as-is
    }
  }
}

if (!customElements.get("relative-link")) {
  customElements.define("relative-link", RelativeLink);
}
